import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayContains',
})
export class ArrayHasObjectPipe implements PipeTransform {

  transform(haystack: Array<unknown>,
            needle: { [key: string]: string | boolean | number; } | string | number | boolean): boolean | null {
    switch (typeof needle) {
      case 'string':
      case 'boolean':
      case 'number':
        return haystack.includes(needle);
      case 'object':
        return haystack.some(item =>
          // eslint-disable-next-line no-prototype-builtins
          Object.keys(needle).every(key => item.hasOwnProperty(key) && item[key] === needle[key]));
      default:
        return null;
    }
  }

}
